import React, { useEffect, useState } from 'react';
import api from '../api/api';

export default function Tasks() {
  const [tasks, setTasks] = useState([]);
  const [message, setMessage] = useState('');

  useEffect(() => {
    api.get('/tasks')
      .then((res) => setTasks(res.data))
      .catch(() => setMessage('Error al obtener tareas.'));
  }, []);

  const applyToTask = async (taskId) => {
    try {
      await api.post('/applications', { task_id: taskId });
      alert('Postulación enviada correctamente.');
    } catch (err) {
      alert(err.response?.data?.message || 'Error al postularse.');
    }
  };

  return (
    <section className="tasks-section">
      <h2>Tareas disponibles</h2>
      {message && <p>{message}</p>}
      <div className="tasks-list">
        {tasks.map((t) => (
          <div key={t.id} className="task-card">
            <h3>{t.title}</h3>
            <p>{t.description}</p>
            <button onClick={() => applyToTask(t.id)}>Postularme</button>
          </div>
        ))}
      </div>
    </section>
  );
}
